module.exports = __webpack_public_path__ + "images/7d41ea5cc6d2467385c85fd80477215c.gif";